<template>
  <div align="center" style="width: 70vw; margin: 40px auto 10px;">
    <div v-if="allDevices.length">
      <div class="text-center my-2">
        <!-- <v-layout row wrap justify-center>
          <v-btn
            fab
            x-small
            class="mx-2"
            @click="fetchPagedDevicesListBack()"
            :disabled="queryForSignage.page === 1"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn
            v-for="i in allDevices.total_pages"
            :key="i"
            fab
            x-small
            class="mx-2"
            :class="{primary: queryForSignage.page === i}"
            @click="fetchPagedDevicesList(i)"
          >{{i}}</v-btn>
          <v-btn
            fab
            x-small
            class="mx-2"
            @click="fetchPagedDevicesListForward() "
            :disabled="queryForSignage.page === allDevices.total_pages"
          >
            <v-icon>arrow_forward</v-icon>
          </v-btn>
        </v-layout>-->
        <v-pagination v-model="queryForSignage.page" :length="signagePageCount" circle class="my-4"></v-pagination>
      </div>
      <v-card-title class="d-flex pt-0 px-0">
        <v-text-field
          dense
          hide-details
          append-icon="search"
          placeholder="Search"
          v-model="search"
          clearable
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-if="allDevices.length"
        :headers="headers"
        :items="allDevices"
        :search="search"
        :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50]
      }"
        :items-per-page="queryForSignage.limit"
        :page.sync="queryForSignage.page"
        @page-count="signagePageCount = $event"
        hide-default-footer
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item,index) in items" :key="index">
              <!-- <td class="text-left">{{item.device_uuid}}</td> -->
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <td class="text-left" v-on="on">{{item.name}}</td>
                </template>
                <span>{{item.device_uuid}}</span>
              </v-tooltip>
              <td class="text-left">{{item.status}}</td>
              <td class="text-left">{{item.racks_enabled ? 'Yes' : 'No'}}</td>
              <td class="text-left">{{item.racks_configured ? 'Yes' : 'No'}}</td>
              <td class="text-left">{{item.online ? 'Yes' : 'No'}}</td>
              <td class="text-left">{{item.location ? item.location.name : '-'}}</td>

              <td class="text-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-menu offset-x transition="slide-x-transition">
                      <template v-slot:activator="{ on: menu }">
                        <v-btn v-on="{...tooltip, ...menu}" fab x-small>
                          <v-icon>more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list class="pa-4">
                        <v-list-item-title>Actions</v-list-item-title>
                        <v-divider></v-divider>
                        <div>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                color="primary"
                                class="mr-1 my-1"
                                dark
                                fab
                                x-small
                                v-on="on"
                                @click="editSignageDevice(item)"
                              >
                                <v-icon class>edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="mr-1 my-1"
                                color="primary"
                                fab
                                x-small
                                @click="openAssignDevice(item)"
                                v-on="on"
                              >
                                <i small class="fas fa-map-marker-alt"></i>
                              </v-btn>
                            </template>
                            <span>Assign To Location</span>
                          </v-tooltip>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="mr-1 my-1"
                                color="primary"
                                fab
                                x-small
                                @click="openBeaconLogsDialog(item)"
                                v-on="on"
                              >
                                <i class="fas fa-clipboard-check"></i>
                              </v-btn>
                            </template>
                            <span>Beacon Logs</span>
                          </v-tooltip> -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="mr-1 my-1"
                                color="primary"
                                fab
                                x-small
                                @click="openCampaignDialog(item)"
                                v-on="on"
                              >
                                <i x-small class="fas fa-bullhorn"></i>
                              </v-btn>
                            </template>
                            <span>Campaigns</span>
                          </v-tooltip>

                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="mr-1 my-1"
                                color="primary"
                                fab
                                x-small
                                @click="openSettingsDialog(item)"
                                v-on="on"
                              >
                                <v-icon>settings</v-icon>
                              </v-btn>
                            </template>
                            <span>Settings</span>
                          </v-tooltip> -->

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="mr-1 my-1 text-white"
                                color="primary"
                                fab
                                x-small
                                @click="openDevicePicturesDialog(item)"
                                v-on="on"
                                :disabled="!(item.racks_configured && item.racks_enabled)"
                              >
                                <!-- <a dark class="white--text"
                                :href="`https://smart-racks-preview.unoapp.io/${item.device_uuid}`" target="_blank">-->
                                <v-icon>camera_alt</v-icon>
                                <!-- </a> -->
                              </v-btn>
                            </template>
                            <span>
                              Pictures
                              <v-icon dark small>open_in_new</v-icon>
                            </span>
                          </v-tooltip>
                        </div>
                      </v-list>
                    </v-menu>
                  </template>
                  <span>Click for actions</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <v-pagination
        v-if="allDevices.length > 20"
        v-model="queryForSignage.page"
        :length="signagePageCount"
        circle
        class="my-4"
      ></v-pagination>

      <!-- Edit Name Model -->
      <v-dialog v-model="editSignageDeviceModal" persistent scrollable :width="700">
        <v-card>
          <v-card-title class="primary text-white">
            Update - {{this.selectedDevice.name}}
            <v-spacer></v-spacer>
            <v-icon @click="closeEditSignageModal" dark>close</v-icon>
          </v-card-title>
          <v-card-text class="pa-8">
            <v-form ref="form">
              <v-text-field
                label="Name"
                v-model="selectedDeviceName"
                @keydown.enter.prevent="confirmNameEdit"
                :rules="[v => !!v || 'Required']"
              ></v-text-field>
            </v-form>
            <v-text-field label="Device UUId" v-model="selectedDevice.device_uuid" readonly></v-text-field>
            <v-row>
              <v-col>
                <strong>Status:</strong>
                <div>{{selectedDevice.status}}</div>
              </v-col>
              <v-col>
                <strong>Online:</strong>
                <v-switch
                  class="mt-0"
                  :label="selectedDevice.online ? 'Yes': 'No'"
                  v-model="selectedDevice.online"
                  disabled
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <strong>Racks Enabled:</strong>
                <v-switch
                  class="mt-0"
                  :label="selectedDevice.racks_enabled ? 'Yes': 'No'"
                  v-model="selectedDevice.racks_enabled"
                  disabled
                ></v-switch>
              </v-col>
              <v-col>
                <strong>Racks Configured:</strong>
                <v-switch
                  class="mt-0"
                  :label="selectedDevice.racks_configured ? 'Yes': 'No'"
                  v-model="selectedDevice.racks_configured"
                  disabled
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small color="error" @click="closeEditSignageModal">Cancel</v-btn>
            <v-btn text small color="success" @click="confirmNameEdit">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Assign To location -->
      <v-dialog v-model="assignToLocationModal" persistent scrollable :width="600">
        <v-card class="grey lighten-4">
          <v-card-title class="primary text-white">
            Assign To location
            <v-spacer></v-spacer>
            <v-icon @click="closeAssignDevice" dark>close</v-icon>
          </v-card-title>
          <!-- <div row wrap class="mt-2 text-center">
            <v-btn
              fab
              x-small
              class="ml-2"
              @click="fetchPagedLocationsListBack"
              :disabled="queryForLocations.page === 1"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-btn
              v-for="i in allLocations.total_pages"
              :key="i"
              fab
              x-small
              class="mx-2"
              :class="{primary: queryForLocations.page === i}"
              @click="fetchPagedLocationsList(i)"
            >{{i}}</v-btn>
            <v-btn
              fab
              x-small
              class="mx-2"
              @click="fetchPagedLocationsListForward"
              :disabled="queryForLocations.page === allLocations.total_pages"
            >
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </div> -->
          <v-card-text class="mt-4 pb-0 px-0">
            <v-list class="grey lighten-4">
              <v-list-item-group v-model="location" color="success">
                <v-list-item
                  v-for="(location, index) in allLocations"
                  :key="location.id"
                  :class="{'primary lighten-3' : selectedDevice.location ? location.id === selectedDevice.location_uuid : ''}"
                >
                  <v-list-item-content @click="selectLocation(location)">
                    <v-list-item-title>{{index+1}}. {{location.name}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small color="error" @click="closeAssignDevice()">Cancel</v-btn>
            <v-btn text small color="success" @click="confirmAssign()">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--  Beacon modal -->
      <v-dialog v-model="beaconModal" :width="400" persistent scrollable>
        <v-card>
          <v-card-title class="primary text-white">
            Beacon Logs
            <v-spacer></v-spacer>
            <v-icon @click="cancelBeaconLogs" dark>close</v-icon>
          </v-card-title>

          <v-card-text class="pa-8">
            <v-form ref="beaconForm">
              <v-menu
                :close-on-content-click="false"
                offset-y
                v-model="startDateMenu"
                :max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    v-on="on"
                    label="Start Date"
                    v-model="startDate"
                    :rules="[v => !!v || 'Required']"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startDate">
                  <v-spacer></v-spacer>
                  <v-btn color="success" text @click="startDateMenu = false">Ok</v-btn>
                </v-date-picker>
              </v-menu>
              <v-menu
                :close-on-content-click="false"
                offset-y
                v-model="endDateMenu"
                :max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    v-on="on"
                    label="End Date"
                    v-model="endDate"
                    :rules="[v => !!v || 'Required']"
                  ></v-text-field>
                </template>

                <v-date-picker v-model="endDate">
                  <v-spacer></v-spacer>
                  <v-btn color="success" text @click="endDateMenu = false">Ok</v-btn>
                </v-date-picker>
              </v-menu>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text @click="cancelBeaconLogs">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="exportBeaconLogs">Export</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="campaignDialog" persistent scrollable :width="700">
        <v-card min-height="300">
          <v-card-title class="primary text-white">
            {{selectedDevice.name ? `${selectedDevice.name} - ` : ''}}
            Campaigns
            <v-spacer></v-spacer>
            <v-icon @click="closeCampaignDialog" dark>close</v-icon>
          </v-card-title>
          <v-card-text class="pa-8 pb-4">
            <campaign></campaign>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click="closeCampaignDialog">Close</v-btn>

            <!-- <v-btn  text color="success">Publish</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="settingsDialog" persistent scrollable :width="350">
        <v-card min-height="300">
          <v-card-title class="primary text-white">
            <!-- {{selectedDevice.name ? `${selectedDevice.name} - ` : ''}} -->
            <v-icon dark class="mr-2">settings</v-icon>Settings
            <v-spacer></v-spacer>
            <v-icon @click="closeSettingsDialog" dark>close</v-icon>
          </v-card-title>
          <v-card-text class="pa-8 pb-4">
            <settings :device="selectedDevice"></settings>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click="closeSettingsDialog">Close</v-btn>

            <!-- <v-btn  text color="success">Publish</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="devicePictureDialog" persistent scrollable :width="600">
        <v-card min-height="300">
          <v-card-title class="primary text-white">
            <v-icon dark class="mr-2">camera_alt</v-icon>
            {{selectedDevice.name}}
            <v-spacer></v-spacer>
            <v-icon @click="closeDevicePicturesDialog" dark>close</v-icon>
          </v-card-title>
          <v-card-text class="pa-8 pb-4">
            <pictures></pictures>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click="closeDevicePicturesDialog">Close</v-btn>

            <!-- <v-btn  text color="success">Publish</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>There are no devices.</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Campaign from './campaign.vue'
import Settings from './settings.vue'
import Pictures from './pictures.vue'

import moment from 'moment'
function initialState () {
  return {
    displayAll: false,
    editSignageDeviceModal: false,
    assignToLocationModal: false,
    beaconModal: false,
    startDate: '',
    endDate: '',
    startDateMenu: false,
    endDateMenu: false,
    campaignDialog: false,
    settingsDialog: false,
    tableActionsMenu: false,
    devicePictureDialog: false,

    headers: [
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Status ',
        // value: 'status',,
        sortable: false,

        width: '10%'
      },
      {
        text: 'Racks Enabled ',
        sortable: false

        // value: 'racks_enabled'
      },
      {
        text: 'Racks Configured',
        sortable: false

        // value: 'racks_configured'
      },
      {
        text: 'Online',
        sortable: false
        // value: 'online'
      },
      {
        text: 'Location',
        sortable: false

        // value: 'online'
      },
      {
        text: 'Actions ',
        sortable: false,
        width: '20%'
        // align: 'center'
      }
    ],
    search: '',
    selectedDevice: {},
    selectedDeviceName: '',
    selectedLocation: {},
    location: '',
    queryForSignage: {
      limit: 50,
      page: 1,
      withLocations: true
    },
    queryForLocations: {
      limit: 100,
      page: 1
    },
    pageSelected: 1,
    signagePageCount: 0,
    locationsPageCount: 0
  }
}
export default {
  data () {
    return initialState()
  },
  components: {
    Campaign,
    Settings,
    Pictures
  },
  async mounted () {
    this.spinner(true)
    try {
      await this.$store.dispatch(
        'signage/GetAllSignageDevicesPagedWithLocations',
        this.queryForSignage
      )
      this.displayAll = true
    } catch (e) {
      this.snackbar({ text: e.response.data.msg })
    }
    this.spinner(false)
  },
  methods: {
    // Open modal to edit the device
    editSignageDevice (device) {
      this.editSignageDeviceModal = true
      this.selectedDevice = device
      this.selectedDeviceName = device.name
      // this.$store.dispatch('signage/GetSignageDeviceDetails', this.selectedDevice.id)
    },

    // Close the edit modal
    closeEditSignageModal () {
      this.editSignageDeviceModal = false
      this.resetAll()
    },

    // Submit the name edit of the signage device
    async confirmNameEdit () {
      if (this.$refs.form.validate()) {
        this.spinner(true)
        try {
          const value = {
            uuid: this.selectedDevice.device_uuid,
            data: {
              name: this.selectedDeviceName
            }
          }

          await this.$store.dispatch('signage/UpdateSignageDeviceName', value)
          setTimeout(async () => {
            await this.$store.dispatch(
              'signage/GetAllSignageDevicesPagedWithLocations',
              this.queryForSignage
            )
            this.snackbar({ text: 'Successfully updated.' })
            this.spinner(false)
            await this.resetAll()
          }, 1000)
        } catch (e) {
          this.snackbar({ text: 'Updated failed.' })
        }
      }
    },

    // Open modal to assign a location to the device
    async openAssignDevice (device) {
      this.assignToLocationModal = true
      this.selectedDevice = device
      await this.$store.dispatch(
        'locations/GetAllLocations',
        this.queryForLocations
      )
    },

    // Close modal to assign a location to the device
    closeAssignDevice () {
      this.assignToLocationModal = false
      this.resetAll()
    },

    // Pass the value of selected location
    selectLocation (location) {
      this.selectedLocation = location
    },

    // Confirm assign location
    async confirmAssign () {
      if ((this.location || this.location === 0) && this.selectedLocation.id) {
        this.spinner(true)

        if (
          this.selectedDevice.location
            ? this.selectedDevice.location.uuid !== this.selectedLocation.id
            : true
        ) {
          try {
            const value = {
              uuid: this.selectedDevice.device_uuid,
              data: {
                location_id: this.selectedLocation.id
              }
            }
            await this.$store.dispatch('signage/AssignLocationToDevice', value)
            // setTimeout(async () => {
            await this.$store.dispatch(
              'signage/GetAllSignageDevicesPagedWithLocations',
              this.queryForSignage
            )
            this.snackbar({ text: 'Successfully assigned location' })
            this.assignToLocationModal = false
            this.resetAll()
            // }, 1000)
          } catch (e) {
            this.snackbar({ text: e.response.data.msg })
          }
        } else {
          this.snackbar({ text: 'You are trying to assign same location.' })
        }
        this.spinner(false)
      } else {
        if (!this.selectedLocation.id) {
          this.snackbar({ text: 'Location not selected.' })
        }
        this.spinner(false)
      }
    },

    // Fetch paged devices
    async fetchPagedDevicesList (page) {
      this.queryForSignage.page = page
      if (page !== this.allDevices.current_page) {
        await this.$store.dispatch(
          'signage/GetAllSignageDevicesPagedWithLocations',
          this.queryForSignage
        )
      }
    },

    async fetchPagedDevicesListBack (page) {
      if (this.queryForSignage.page > 1) {
        this.queryForSignage.page--
        await this.$store.dispatch(
          'signage/GetAllSignageDevicesPagedWithLocations',
          this.queryForSignage
        )
      }
    },
    async fetchPagedDevicesListForward (page) {
      if (this.queryForSignage.page < this.allDevices.total_pages) {
        this.queryForSignage.page++
      }
      await this.$store.dispatch(
        'signage/GetAllSignageDevicesPagedWithLocations',
        this.queryForSignage
      )
    },

    // Fetch paged locations
    async fetchPagedLocationsList (page) {
      this.spinner(true)
      this.queryForLocations.page = page
      if (page !== this.allLocations.current_page) {
        await this.$store.dispatch(
          'locations/GetAllLocations',
          this.queryForLocations
        )
      }
      this.spinner(false)
    },

    async fetchPagedLocationsListBack () {
      this.spinner(true)
      if (this.queryForLocations.page > 1) {
        this.queryForLocations.page--
        await this.$store.dispatch(
          'locations/GetAllLocations',
          this.queryForLocations
        )
      }
      this.spinner(false)
    },

    async fetchPagedLocationsListForward () {
      this.spinner(true)
      if (this.queryForLocations.page < this.allLocations.total_pages) {
        this.queryForLocations.page++
      }
      await this.$store.dispatch(
        'locations/GetAllLocations',
        this.queryForLocations
      )
      this.spinner(false)
    },

    // Open model for export Beacon Logs
    openBeaconLogsDialog (device) {
      this.selectedDevice = device
      this.beaconModal = true
    },
    // Cancel/Close Beacon logs modal
    cancelBeaconLogs () {
      this.$refs.beaconForm.resetValidation()
      this.resetAll()
    },

    // Download/export beacon logs as csv
    dateIsBefore () {
      const startDate = this.startDate.split('-')
      const endDate = this.endDate.split('-')
      let startDateNumberArray = []
      let endDateNumberArray = []

      startDate.forEach(el => {
        let a = Number(el)
        startDateNumberArray.push(a)
      })

      endDate.forEach(el => {
        let a = Number(el)
        endDateNumberArray.push(a)
      })

      let isbefore = moment(startDateNumberArray).isBefore(endDateNumberArray)
      return isbefore
    },
    async exportBeaconLogs () {
      const isbefore = this.dateIsBefore()
      if (this.$refs.beaconForm.validate()) {
        this.spinner(true)
        const data = {
          id: this.selectedDevice.id,
          startDate: this.startDate,
          endDate: this.endDate
        }
        try {
          await this.$store.dispatch('signage/GetBeaconLogs', data)
          this.exportCSVBeaconLogs()
          this.resetAll()
        } catch (e) {
          this.snackbar({ text: e.response.data.msg })
        }
        this.spinner(false)
      } else {
        if (this.$refs.beaconForm.validate() && !isbefore) {
          this.snackbar({ text: 'Start date should be before end date.' })
        }
      }
    },

    // Set up the data from the server in csv format
    exportCSVBeaconLogs () {
      // map according to  desired keys
      const data = this.beaconLogs.map(el => ({
        beacon_uuid: el.beacon_uuid,
        record_name: el.content_name,
        content_type: el.content_type,
        content: el.content,
        shown: el.shown,
        triggered_on_date: moment(el.triggered_at)
          .local()
          .format('YYYY-MM-DD'),
        triggered_at_time: moment(el.triggered_at)
          .local()
          .format('HH:mm:ss')
      }))
      const csvRows = []

      // get the headers
      const headers = Object.keys(data[0])
      csvRows.push(headers.join(','))
      // loop over the rows
      for (const row of data) {
        const values = headers.map(header => {
          if (row['shown'] === true) {
            row['shown'] = 'yes'
          } else if (row['shown'] === false) {
            row['shown'] = 'no'
          }
          let escaped = ('' + row[header]).replace(/"/g, '\\"')
          return `"${escaped}"`
        })
        csvRows.push(values.join(','))
      }
      const csv = csvRows.join('\r\n')
      this.download(csv)
    },

    // download csv
    download (data) {
      const blob = new Blob([data], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('hidden', '')
      a.setAttribute('href', url)
      a.setAttribute(
        'download',
        `beacon_logs_${this.selectedDevice.id}_${this.startDate}_${this.endDate}.csv`
      )
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    async openCampaignDialog (device) {
      this.spinner(true)
      this.selectedDevice = device
      try {
        await this.fetchDevicesCampaign(device.device_uuid)
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
      }
      this.campaignDialog = true
      this.spinner(false)
    },

    closeCampaignDialog () {
      this.campaignDialog = false
      this.removeDeviceCampaigns([])
      this.resetAll()
    },

    openSettingsDialog (device) {
      this.selectedDevice = device
      this.settingsDialog = true
    },

    closeSettingsDialog () {
      this.settingsDialog = true
      this.resetAll()
    },

    async openDevicePicturesDialog (device) {
      this.selectedDevice = device
      this.devicePictureDialog = true
      try {
        await this.$store.dispatch('signage/GetAllRequestsByDevice', {
          uuid: device.device_uuid
        })
      } catch (err) {
        this.snackbar({ text: err.response.data.msg })
      }
    },

    closeDevicePicturesDialog () {
      this.devicePictureDialog = false
      this.setDeviceRequests([])
      this.resetAll()
    },

    resetAll () {
      Object.assign(this.$data, initialState())
    },
    ...mapMutations({
      removeDeviceCampaigns: 'signage/SET_DEVICES_CAMPAIGN',
      setDeviceRequests: 'signage/SET_DEVICES_REQUESTS'
    }),
    ...mapActions({
      fetchDevicesCampaign: 'signage/GetCampaignsForDevice'
    })
  },
  computed: {
    selectedDeviceStatus () {
      if (this.selectedDevice.status === 'activated') {
        return true
      }
      return false
    },
    ...mapGetters({
      allDevices: 'signage/allDevicesPagedWithLocations',
      allLocations: 'locations/allLocations',
      beaconLogs: 'signage/beaconLogs'
    })
  }
}
</script>

<style>
</style>
